import React from 'react';

var Comment = function Comment(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M12 16h5.68A1.32 1.32 0 0 0 19 14.68V7.32A1.32 1.32 0 0 0 17.68 6H6.32A1.32 1.32 0 0 0 5 7.32v7.36c0 .729.591 1.32 1.32 1.32H8l2 2.667L12 16zm5.68-12A3.32 3.32 0 0 1 21 7.32v7.36A3.32 3.32 0 0 1 17.68 18H13l-3 4-3-4h-.68A3.32 3.32 0 0 1 3 14.68V7.32A3.32 3.32 0 0 1 6.32 4h11.36zM8 12a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z",
    fill: "currentColor",
    fillRule: "nonzero"
  }));
};

Comment.defaultProps = {
  role: "img",
  viewBox: "0 0 24 24"
};
import iconHandler from './hoc';
export { Comment as icon };
export default iconHandler(Comment);


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/icons/dist/Comment.js
// module id = 591
// module chunks = 0